"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductSizeEdit = void 0;
const Base_1 = require("./Base");
exports.PostProductSizeEdit = {
    url: Base_1.URL_BASE + "/ProductSizeEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductSizeEdit.js.map